import script from "./Language.vue?vue&type=script&setup=true&lang=js"
export * from "./Language.vue?vue&type=script&setup=true&lang=js"

import "./Language.vue?vue&type=style&index=0&id=1aeee272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aeee272"]])

export default __exports__